import React, { useEffect } from "react";
import AllergyDetails from "../../../ConsultationNotes/VitalTabs/MedicalHistory/AllergyDetails";
import PastMedicalHistory from "../../../ConsultationNotes/VitalTabs/MedicalHistory/PastMedicalHistory";
import SurgicalHistory from "../../../ConsultationNotes/VitalTabs/MedicalHistory/SurgicalHistory";
import FamilyHistory from "../../../ConsultationNotes/VitalTabs/MedicalHistory/FamilyHistory";
import SocialHistory from "../../../ConsultationNotes/VitalTabs/MedicalHistory/SocialHistory";
import Medication from "../../../ConsultationNotes/VitalTabs/MedicalHistory/Medication";
import ChronicCondition from "../../../ConsultationNotes/VitalTabs/MedicalHistory/ChronicCondition";
import Vaccinations from "../../../ConsultationNotes/VitalTabs/MedicalHistory/Vaccinations";
import { setSelectedRpmPatient } from "../../../../../Redux/actions/rpmActions";
import { useDispatch, useSelector } from "react-redux";
import Layouts from "../../../../Layouts";
import { useHistory } from "react-router-dom";

function ViewAllHistory() {
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);
  const history = useHistory();
  const historyBack = () => {
    history.goBack();
  };

  return (
    <Layouts>
      <div>
        <div className="m-2 flex justify-between items-center">
          <h1 className="font-bold text-xl">Medical History</h1>
          <h1
            className="font-bold text-xl border rounded-md p-2 cursor-pointer"
            onClick={historyBack}
          >{`<- Back`}</h1>
        </div>
        <div className="grid grid-cols-3">
          <AllergyDetails
            permissionData={{ medicalHistory: "Y" }}
            selectedPatient={selectedRpmPatient}
          />
          <PastMedicalHistory
            permissionData={{ medicalHistory: "Y" }}
            selectedPatient={selectedRpmPatient}
          />
          <SurgicalHistory
            permissionData={{ medicalHistory: "Y" }}
            selectedPatient={selectedRpmPatient}
          />
          <FamilyHistory
            permissionData={{ medicalHistory: "Y" }}
            selectedPatient={selectedRpmPatient}
          />
          <SocialHistory
            permissionData={{ medicalHistory: "Y" }}
            selectedPatient={selectedRpmPatient}
          />
          <Medication
            permissionData={{ medicalHistory: "Y" }}
            selectedPatient={selectedRpmPatient}
          />
          <ChronicCondition
            permissionData={{ medicalHistory: "Y" }}
            selectedPatient={selectedRpmPatient}
          />
          <Vaccinations
            permissionData={{ medicalHistory: "Y" }}
            selectedPatient={selectedRpmPatient}
          />
        </div>
      </div>
    </Layouts>
  );
}

export default ViewAllHistory;
